import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {reactTableText} from '../../../../constants/configs';
import PairZonesManageForm from "../../../../containers/PairZonesManageForm";
import ReactTableSelectFilter from "../../../../components/ReactTableSelectFilter";
import ModalManager from '../../../../components/modal/ModalManager';
import Rbac from '../../../../components/Rbac';
import ReactTable from 'react-table';
import {join, map} from 'lodash';
import Api from "../../../../services/Api";
import {store} from "../../../../AppRenderer";

class PairsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pairs: [],
      original: [],
      loading: true,
    };
    this.renderPairFilter = this.renderPairFilter.bind(this);
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/pairs');
      this.setState({
        pairs: data,
        original: data,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onPressEdit = pair => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Edit {{name}} pair zones', {name: pair.name}),
      body: <PairZonesManageForm pair={pair} afterSubmit={this.fetchData}/>
    });
  };

  renderPairFilter({filter, onChange}) {
    const {t} = this.props;
    const options = store.getState().general.pairs.map(pair => ({
      value: pair.name, label: pair.name,
    }));
    return <ReactTableSelectFilter
      filter={filter}
      onChange={value => {
        onChange(value);
        this.onSelectPair(value);
      }}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  onSelectPair = selected => {
    this.setState(({original}) => ({
      pairs: selected ?
        original.filter(item => item.name === selected)
        :
        original
    }));
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      width: 150,
      className: 'font-weight-semibold',
      filterable: true,
      Filter: this.renderPairFilter,
    },
    {
      Header: t('Categories'),
      accessor: 'zones',
      Cell: props => {
        if (props.value) {
          return <span>{join(map(props.value, item => item.name), ', ')}</span>;
        }
        return null;
      }
    },
    {
      Header: t('Actions'),
      accessor: 'name',
      Cell: props => <div className='d-flex flex-row align-items-center'>
        <i
          className="simple-icon-pencil edit-icon mr-4 cursor-pointer"
          onClick={() => {this.onPressEdit(props.original);}}
        />
      </div>,
      width: 70,
      show: Rbac.hasPermission('update_zone'),
    },
  ];

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <ReactTable
          manual
          className="-highlight"
          data={this.state.pairs}
          loading={this.state.loading}
          sortable={false}
          resizable={true}
          showPagination={false}
          columns={this.getColumns(t)}
          pageSize={this.state.pairs.length || 5}
          style={{
            width: '100%',
          }}
          {...reactTableText}
        />
      </Fragment>
    );
  }
}

export default withTranslation()(PairsList);
